import React from "react";
import Routers from "./router";
import Helmet from "react-helmet";



function App() {


  return (
    <div className="App App-background-color">
    <Helmet>
        <title>goID™ Issuance System Portal</title>
        <meta name="description" content="goID™ Issuance System Portal" />
    </Helmet>
      <Routers />
    </div>
  );
}

export default App;
